import { render, staticRenderFns } from "./DeleteAccountForm.vue?vue&type=template&id=81db0436&scoped=true&"
import script from "./DeleteAccountForm.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccountForm.vue?vue&type=style&index=0&id=81db0436&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81db0436",
  null
  
)

export default component.exports